"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkStyled = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colors = require("../style/colors");
var _fonts = require("../style/fonts");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const LinkStyled = exports.LinkStyled = /*#__PURE__*/_styledComponents.default.a.withConfig({
  displayName: "style__LinkStyled",
  componentId: "bufferapp-ui__sc-nzvu5m-0"
})(["font-family:", ";font-size:", ";font-weight:", ";line-height:", ";cursor:pointer;text-decoration:none;color:", ";:hover{color:", ";}"], _fonts.fontFamily, _fonts.fontSize, props => props.fontWeight, _fonts.lineHeight, _colors.blue, _colors.blueDark);